import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import Signup from "./Signup";

const SignupRoute = () => {
  const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

  if (!siteKey) {
    console.log("Missing RECAPTCHA site key");
  }

  return (
    <GoogleReCaptchaProvider reCaptchaKey={siteKey}>
      <Signup />
    </GoogleReCaptchaProvider>
  );
};

export default SignupRoute;
